module.exports = __webpack_public_path__ + "img/ENLATADOS.9a3fd9b7.jpg";